import { axiosWalletRequest, METHOD } from '../api/Requests';

export const getAll = () => axiosWalletRequest(`Moeda`, METHOD.GET);

export const getCoinByCountry = (id) => axiosWalletRequest(`Moeda/${id}`, METHOD.GET);

